export const Alert = ({ status, children }) => {
  let text = "";
  if (status === "success") text = "Success";
  if (status === "danger") text = "Failed";
  return (
    <div className={"alert alert-dismissible alert-" + status} role="alert">
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
      <span>
        <strong>{text}</strong>
        &nbsp;&nbsp;{children}
      </span>
    </div>
  );
};
